import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  ChannelsPublicationFeature, ChannelsPublicationPackageFeature
} from '@app/src/views/StepTwo/channelPublication';
import { CATEGORIES } from '@app/src/config/categories';
import { useLocation } from 'react-router-dom';
import { setUserPasarella } from '@app/src/common/session';
import { clearMyPackageAvailableAll } from '@app/src/common/CounterAvailable';

export const StepTwo: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const getAliasCategory = () => location.pathname.split('-')[2];
  const categoryConfig = CATEGORIES[getAliasCategory()];
  const urlPrintPurchase = categoryConfig.paths.purchasePrint.stepTypePublication;

  useEffect(() => {
    let typeAction = 'consume-print';
    if (urlPrintPurchase === location.pathname) {
      typeAction = 'purchase-print';
    }
    if (typeAction === 'consume-print') {
      dispatch(clearMyPackageAvailableAll());
    }
    dispatch(setUserPasarella(typeAction));
  }, []);

  return (
    <React.Fragment>
      {
        (location.pathname === urlPrintPurchase) ?
          <ChannelsPublicationFeature />
          :
          <ChannelsPublicationPackageFeature />

      }
    </React.Fragment>
  )
};
